<template>
  <div class="banner">
    <div>
      <div class="banner__title">{{ title }}</div>
      <div class="banner__subtitle">{{ subtitle }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: {
    title: String,
    subtitle: String,
  },
};
</script>

<style scoped lang="scss">
.banner {
  min-height: 200px;
  padding: 70px 18%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: url(~@/assets/banner.jpg);
  background-size: cover;
  background-position: center;
  color: white;

  &__subtitle {
    font-size: 24px;
    line-height: 1.25;
    text-shadow: 0px 0px 20px $stjude-red;
  }

  &__title {
    font-weight: 900;
    font-size: 64px;
    line-height: 64px;
    text-align: center;
    letter-spacing: -0.02em;
    font-feature-settings: 'pnum' on, 'lnum' on;
  }
}

@media screen and (max-width: 960px) {
  .banner {
    min-height: 130px;

    &__subtitle {
      font-size: 18px;
    }
    &__title {
      font-size: 36px;
    }
  }
}
</style>
